var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-top-bar"},[_c('div',{staticClass:"btn-back",on:{"click":_vm.goBack}}),_c('div',{staticClass:"top-bar-title"},[_vm._v(_vm._s(_vm.topTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }